import React, { useEffect } from "react";
import FormLogin from "./FormLogin";

import "./style.css";

const LoginPanel = () => {
  useEffect(() => {
    document.title = "Redech | Login"
  }, [])

  return (
    <div>
      <div id="page">
      <div id="login-panel">
          <FormLogin />
      </div>
      </div>
    </div>
  );
}

export default LoginPanel;